import { render, staticRenderFns } from "./TransferServiceDetails.vue?vue&type=template&id=672858ac&"
import script from "./TransferServiceDetails.vue?vue&type=script&lang=js&"
export * from "./TransferServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransferServiceDetails.vue"
export default component.exports